@import '../../../theme.scss';

verdocs-organization-card {
  font-family: $primary-font;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid $light-border-color;
  background: #ffffff;
  border-radius: 8px;
  padding: 7px 15px;

  .icon {
    flex: 0;
    height: 24px;
    width: 24px;
    margin: 0 14px 0 0;

    svg {
      fill: $icon-color;
      height: 24px;
      width: 24px;
    }
  }

  .content {
    margin-top: 2px;
  }
}

.verdocs-org-card-popup {
  font-family: $primary-font;
  background: #ffffff;
  border-radius: 10px;
  width: 326px;
  padding: 20px 40px 0 40px;
  flex-direction: column;
  flex-wrap: nowrap;
  border: 1px solid $light-border-color;

  .popup-header-with-logo {
    display: flex;
    flex: 0;
    gap: 20px;
    flex-direction: column;
    margin: 0 0 20px 0;
    font-size: 21px;
    line-height: 16px;
    color: $secondary-color;

    img {
      max-width: 300px;
      max-height: 50px;
    }
  }

  .popup-header {
    display: flex;
    flex: 0;
    gap: 20px;
    flex-direction: row;
    align-items: flex-end;
    margin: 0 0 20px 0;
    font-size: 21px;
    line-height: 16px;
    color: $secondary-color;
  }

  .popup-body {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    text-transform: uppercase;
  }

  .status {
    transform: scale(1.5);
    width: 24px;
    height: 24px;
  }

  .field {
    margin: 0 0 20px 0;

    strong {
      color: $label-color-very-light;
      display: block;
      margin: 0 0 5px 0;
    }

    a {
      color: $verdocs-purple;
      text-transform: uppercase;
    }
  }
}
